module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Nudge Console")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/nudge-console/dashboard"
    }
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Edit campaign")])])]), _vm._v(" "), _c('section', {
    staticClass: "content nc-page"
  }, [(_vm.loadError) ? _c('div', {
    staticClass: "nc-surface nc-empty"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "nc-empty-title"
  }, [_vm._v("Couldn't open this campaign")]), _vm._v(" "), _c('div', {
    staticClass: "nc-empty-text"
  }, [_vm._v("\n        " + _vm._s(_vm.loadError) + "\n        "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/nudge-console/dashboard"
    }
  }, [_vm._v("Back to the Dashboard")])], 1)]) : (_vm.raw) ? [_c('div', {
    staticClass: "ec-topbar"
  }, [_c('router-link', {
    staticClass: "nc-btn nc-btn-ghost nc-btn-sm",
    attrs: {
      "to": "/nudge-console/dashboard"
    }
  }, [_vm._v("← Back")]), _vm._v(" "), _c('h2', {
    staticClass: "ec-topbar-title"
  }, [_vm._v("Edit campaign — " + _vm._s(_vm.raw.opportunity_name))])], 1), _vm._v(" "), _c('div', {
    staticClass: "ec-sheet"
  }, [_c('div', {
    staticClass: "ec-sheet-head"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ec-head-main"
  }, [_c('div', {
    staticClass: "ec-head-line"
  }, [_c('span', {
    staticClass: "ec-head-name"
  }, [_vm._v(_vm._s(_vm.customerName) + " — " + _vm._s(_vm.raw.opportunity_name))]), _vm._v(" "), _c('span', {
    staticClass: "nc-badge",
    class: _vm.statusBadgeClass
  }, [_vm._v(_vm._s(_vm.statusLabel))]), _vm._v(" "), _c('span', {
    staticClass: "nc-badge nc-badge-teal"
  }, [_vm._v(_vm._s(_vm.countryName))])]), _vm._v(" "), _c('div', {
    staticClass: "ec-head-sub"
  }, [_vm._v("\n              " + _vm._s(_vm.typeText) + " · " + _vm._s(_vm.sessionText) + "\n              "), (_vm.triggerText) ? _c('span', [_vm._v(" · " + _vm._s(_vm.triggerText))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ec-head-tags"
  }, [_c('span', {
    staticClass: "ec-tag"
  }, [_vm._v(_vm._s(_vm.journeyName))]), _vm._v(" "), _c('span', {
    staticClass: "ec-tag"
  }, [_vm._v(_vm._s(_vm.languageCountText))]), _vm._v(" "), _c('span', {
    staticClass: "ec-tag",
    class: {
      'ec-tag-ok': _vm.hasTemplate
    }
  }, [(_vm.hasTemplate) ? _c('i', {
    staticClass: "fa fa-check"
  }) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.hasTemplate ? 'Approved template' : 'No template') + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ec-body"
  }, [_c('aside', {
    staticClass: "ec-rail"
  }, [_c('h4', {
    staticClass: "ec-rail-title"
  }, [_vm._v("Campaign")]), _vm._v(" "), _c('div', {
    staticClass: "ec-rail-row"
  }, [_c('label', {
    staticClass: "ec-rail-label",
    attrs: {
      "for": "ec-name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "nc-input ec-rail-input",
    attrs: {
      "id": "ec-name",
      "type": "text",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "ec-rail-title"
  }, [_vm._v(_vm._s(_vm.isBatch ? 'Schedule' : 'Trigger'))]), _vm._v(" "), (_vm.isBatch) ? [_c('div', {
    staticClass: "ec-rail-row"
  }, [_c('label', {
    staticClass: "ec-rail-label",
    attrs: {
      "for": "ec-deploy-date"
    }
  }, [_vm._v("Deploy on")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.deployDate),
      expression: "form.deployDate"
    }],
    staticClass: "nc-input ec-rail-input",
    attrs: {
      "id": "ec-deploy-date",
      "type": "date"
    },
    domProps: {
      "value": (_vm.form.deployDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "deployDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ec-rail-row"
  }, [_c('label', {
    staticClass: "ec-rail-label",
    attrs: {
      "for": "ec-deploy-time"
    }
  }, [_vm._v("At")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.deployTime),
      expression: "form.deployTime"
    }],
    staticClass: "nc-input ec-rail-input",
    attrs: {
      "id": "ec-deploy-time",
      "type": "time"
    },
    domProps: {
      "value": (_vm.form.deployTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "deployTime", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ec-rail-note"
  }, [_vm._v("\n                Your timezone (" + _vm._s(_vm.localZone) + "), not the campaign country's — the schema stores\n                one instant and nothing resolves a per-country timezone on this path yet.\n              ")])] : (_vm.raw.is_in_session) ? [_c('div', {
    staticClass: "ec-rail-row"
  }, [_c('label', {
    staticClass: "ec-rail-label",
    attrs: {
      "for": "ec-hours"
    }
  }, [_vm._v("Hours")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.sendHours),
      expression: "form.sendHours"
    }],
    staticClass: "nc-input ec-rail-input",
    attrs: {
      "id": "ec-hours",
      "type": "number",
      "min": "0",
      "max": "23"
    },
    domProps: {
      "value": (_vm.form.sendHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "sendHours", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ec-rail-row"
  }, [_c('label', {
    staticClass: "ec-rail-label",
    attrs: {
      "for": "ec-minutes"
    }
  }, [_vm._v("Minutes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.sendMinutes),
      expression: "form.sendMinutes"
    }],
    staticClass: "nc-input ec-rail-input",
    attrs: {
      "id": "ec-minutes",
      "type": "number",
      "min": "0",
      "max": "59"
    },
    domProps: {
      "value": (_vm.form.sendMinutes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "sendMinutes", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ec-rail-note"
  }, [_vm._v("\n                Silence inside a live conversation before the nudge fires. Up to 23 hours;\n                0:00 fires immediately.\n              ")])] : [_c('div', {
    staticClass: "ec-rail-row"
  }, [_c('label', {
    staticClass: "ec-rail-label",
    attrs: {
      "for": "ec-window"
    }
  }, [_vm._v("Inactive for")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.windowValue),
      expression: "form.windowValue"
    }],
    staticClass: "nc-input ec-rail-input",
    attrs: {
      "id": "ec-window",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.form.windowValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "windowValue", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ec-rail-row"
  }, [_c('label', {
    staticClass: "ec-rail-label",
    attrs: {
      "for": "ec-window-unit"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('nv-select', {
    staticClass: "nc-input ec-rail-input",
    attrs: {
      "id": "ec-window-unit"
    },
    model: {
      value: (_vm.form.windowUnit),
      callback: function($$v) {
        _vm.$set(_vm.form, "windowUnit", $$v)
      },
      expression: "form.windowUnit"
    }
  }, [_c('option', {
    attrs: {
      "value": "hrs"
    }
  }, [_vm._v("hours")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "days"
    }
  }, [_vm._v("days")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "ec-rail-note"
  }, [_vm._v("\n                Minimum 24 hours, or 1 day. 0 fires as soon as the user goes inactive — some\n                older campaigns are stored that way.\n              ")])], _vm._v(" "), (!_vm.raw.is_in_session && !_vm.isBatch) ? [_c('h4', {
    staticClass: "ec-rail-title"
  }, [_vm._v("Frequency")]), _vm._v(" "), _c('div', {
    staticClass: "ec-rail-row"
  }, [_c('label', {
    staticClass: "ec-rail-label",
    attrs: {
      "for": "ec-max-nudges"
    }
  }, [_vm._v("Max per user")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.maxNudges),
      expression: "form.maxNudges"
    }],
    staticClass: "nc-input ec-rail-input",
    attrs: {
      "id": "ec-max-nudges",
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.form.maxNudges)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "maxNudges", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ec-rail-row"
  }, [_c('label', {
    staticClass: "ec-rail-label",
    attrs: {
      "for": "ec-cooldown"
    }
  }, [_vm._v("Cooldown")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.cooldownDays),
      expression: "form.cooldownDays"
    }],
    staticClass: "nc-input ec-rail-input",
    attrs: {
      "id": "ec-cooldown",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.form.cooldownDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "cooldownDays", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ec-rail-note"
  }, [_vm._v("Cooldown is in days — how long before this campaign may nudge the same user again.")])] : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "ec-rail-title"
  }, [_vm._v("Set in the wizard")]), _vm._v(" "), _c('div', {
    staticClass: "ec-rail-fact"
  }, [_c('span', {
    staticClass: "ec-rail-fact-label"
  }, [_vm._v("Country")]), _c('span', {
    staticClass: "ec-rail-fact-value"
  }, [_vm._v(_vm._s(_vm.countryName))])]), _vm._v(" "), _c('div', {
    staticClass: "ec-rail-fact"
  }, [_c('span', {
    staticClass: "ec-rail-fact-label"
  }, [_vm._v("Customer")]), _c('span', {
    staticClass: "ec-rail-fact-value"
  }, [_vm._v(_vm._s(_vm.customerName))])]), _vm._v(" "), _c('div', {
    staticClass: "ec-rail-fact"
  }, [_c('span', {
    staticClass: "ec-rail-fact-label"
  }, [_vm._v("Journey")]), _c('span', {
    staticClass: "ec-rail-fact-value"
  }, [_vm._v(_vm._s(_vm.journeyName))])]), _vm._v(" "), _c('div', {
    staticClass: "ec-rail-fact"
  }, [_c('span', {
    staticClass: "ec-rail-fact-label"
  }, [_vm._v("Window kind")]), _c('span', {
    staticClass: "ec-rail-fact-value"
  }, [_vm._v(_vm._s(_vm.sessionText))])]), _vm._v(" "), _c('p', {
    staticClass: "ec-rail-note"
  }, [_vm._v("\n              Changing any of these changes what the rest of the campaign is allowed to\n              contain — the journey decides the language list, the keywords and the template\n              all at once. Rebuild it in\n              "), _c('router-link', {
    attrs: {
      "to": "/nudge-console/create-campaign"
    }
  }, [_vm._v("Create Campaign")]), _vm._v(".\n            ")], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "ec-main"
  }, [(_vm.errors.length) ? _c('div', {
    staticClass: "nc-notice nc-notice-warn ec-errors"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.errors.length) + " thing" + _vm._s(_vm.errors.length === 1 ? '' : 's') + " to fix before saving:")]), _vm._v(" "), _vm._l((_vm.errors), function(message, i) {
    return _c('span', {
      key: i,
      staticClass: "ec-error-item"
    }, [_vm._v(_vm._s(message))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.templateWarnings.length) ? _c('div', {
    staticClass: "nc-notice nc-notice-warn ec-errors"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Template setup to check — sends will fail until it's fixed:")]), _vm._v(" "), _vm._l((_vm.templateWarnings), function(message, i) {
    return _c('span', {
      key: ("w" + i),
      staticClass: "ec-error-item"
    }, [_vm._v(_vm._s(message))])
  })], 2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.form.groups), function(group, gi) {
    return _c('div', {
      key: group.key,
      staticClass: "ec-group"
    }, [_c('div', {
      staticClass: "ec-main-head"
    }, [_c('h4', {
      staticClass: "ec-main-title"
    }, [_vm._v("\n                  Nudge content\n                  "), _c('span', {
      staticClass: "ec-main-title-sep"
    }, [_vm._v("—")]), _vm._v("\n                  " + _vm._s(_vm.variantLabel(gi)) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "ec-main-head-actions"
    }, [(_vm.form.groups.length > 1) ? _c('div', {
      staticClass: "ec-split"
    }, [_c('label', {
      attrs: {
        "for": ("ec-split-" + gi)
      }
    }, [_vm._v("Traffic")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.splitPercent),
        expression: "group.splitPercent"
      }],
      staticClass: "nc-input ec-split-input",
      attrs: {
        "id": ("ec-split-" + gi),
        "type": "number",
        "min": "1",
        "max": "99"
      },
      domProps: {
        "value": (group.splitPercent)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(group, "splitPercent", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ec-split-unit"
    }, [_vm._v("%")])]) : _vm._e(), _vm._v(" "), (group.messages.length > 1) ? _c('button', {
      staticClass: "nc-btn nc-btn-ghost nc-btn-sm",
      on: {
        "click": function($event) {
          return _vm.toggleAll(group)
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.allOpen(group) ? 'fa-compress' : 'fa-th-list'
    }), _vm._v("\n                    " + _vm._s(_vm.allOpen(group) ? 'Collapse all' : 'View / edit all languages') + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "nc-btn nc-btn-sm",
      class: _vm.previewOn(group) ? 'nc-btn-primary' : 'nc-btn-ghost',
      on: {
        "click": function($event) {
          return _vm.togglePreview(group)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-whatsapp"
    }), _vm._v("\n                    " + _vm._s(_vm.previewOn(group) ? 'Hide preview' : 'WhatsApp preview') + "\n                  ")])])]), _vm._v(" "), _c('div', {
      staticClass: "ec-template-line"
    }, [_c('span', {
      staticClass: "ec-template-label"
    }, [_vm._v("Template")]), _vm._v(" "), _c('span', {
      staticClass: "ec-template-value"
    }, [_vm._v(_vm._s(_vm.templateName(group.templateId)))])]), _vm._v(" "), (_vm.groupMedia(group)) ? _c('div', {
      staticClass: "ec-media"
    }, [_c('div', {
      staticClass: "ec-media-head"
    }, [_c('span', {
      staticClass: "ec-template-label"
    }, [_vm._v("Header " + _vm._s(_vm.groupMedia(group).label.toLowerCase()))]), _vm._v(" "), (_vm.mediaRows(group).length < 2) ? _c('span', {
      staticClass: "ec-template-value"
    }, [_vm._v(_vm._s(_vm.groupMedia(group).mediaName || 'No file set'))]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "nc-btn nc-btn-ghost nc-btn-sm",
      attrs: {
        "disabled": _vm.mediaPickerFor(group).loading
      },
      on: {
        "click": function($event) {
          return _vm.toggleMediaPicker(group)
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.isPickerOpenFor(group, null) ? 'fa-times' : 'fa-exchange'
    }), _vm._v("\n                    " + _vm._s(_vm.isPickerOpenFor(group, null) ? 'Close' : (_vm.mediaRows(group).length > 1 ? 'Change for all languages' : 'Change media')) + "\n                  ")])]), _vm._v(" "), (_vm.mediaRows(group).length < 2) ? _c('div', {
      staticClass: "ec-media-showcase"
    }, [_c('media-preview', {
      attrs: {
        "format": _vm.groupMedia(group).format,
        "media-id": _vm.groupMedia(group).mediaId,
        "media-name": _vm.groupMedia(group).mediaName || '',
        "file-name": _vm.groupMedia(group).fileName || '',
        "country-id": _vm.raw.country_id,
        "language-id": _vm.groupMedia(group).languageId
      }
    })], 1) : _c('div', {
      staticClass: "ec-media-langs"
    }, _vm._l((_vm.mediaRows(group)), function(row) {
      return _c('div', {
        key: row.language_id,
        staticClass: "ec-media-lang"
      }, [_c('span', {
        staticClass: "ec-var-label"
      }, [_vm._v(_vm._s(row.language))]), _vm._v(" "), _c('div', {
        staticClass: "ec-media-lang-preview"
      }, [_c('media-preview', {
        attrs: {
          "compact": "",
          "show-caption": false,
          "format": row.turn_template_data.HEADER_FORMAT,
          "media-id": row.media_id,
          "media-name": row.media_name || '',
          "file-name": row.media_file_name || '',
          "country-id": _vm.raw.country_id,
          "language-id": row.language_id,
          "missing-text": ": no file set"
        }
      })], 1), _vm._v(" "), _c('span', {
        staticClass: "ec-media-lang-name"
      }, [_vm._v(_vm._s(row.media_name || 'No file set'))]), _vm._v(" "), _c('button', {
        staticClass: "nc-btn nc-btn-ghost nc-btn-sm",
        attrs: {
          "disabled": _vm.mediaPickerFor(group).loading
        },
        on: {
          "click": function($event) {
            return _vm.toggleMediaPicker(group, row)
          }
        }
      }, [_c('i', {
        staticClass: "fa",
        class: _vm.isPickerOpenFor(group, row) ? 'fa-times' : 'fa-exchange'
      }), _vm._v("\n                      " + _vm._s(_vm.isPickerOpenFor(group, row) ? 'Close' : 'Change') + "\n                    ")])])
    }), 0), _vm._v(" "), (_vm.groupMedia(group).problem) ? _c('p', {
      staticClass: "ec-media-problem"
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle"
    }), _vm._v(" " + _vm._s(_vm.groupMedia(group).problem) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.documentRows(group).length) ? _c('div', {
      staticClass: "ec-vars ec-filenames"
    }, [_vm._m(3, true), _vm._v(" "), _vm._l((_vm.documentRows(group)), function(row) {
      return _c('div', {
        key: row.language_id,
        staticClass: "ec-var-row"
      }, [_c('span', {
        staticClass: "ec-var-label"
      }, [_vm._v(_vm._s(row.language))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.fileNameDrafts[_vm.fileNameKey(group, row)]),
          expression: "fileNameDrafts[fileNameKey(group, row)]"
        }],
        staticClass: "nc-input ec-var-text",
        attrs: {
          "type": "text",
          "maxlength": "100",
          "placeholder": "e.g. Clinic visit guide.pdf",
          "aria-label": ((row.language) + " file name")
        },
        domProps: {
          "value": (_vm.fileNameDrafts[_vm.fileNameKey(group, row)])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.fileNameDrafts, _vm.fileNameKey(group, row), $event.target.value)
          }
        }
      })])
    }), _vm._v(" "), _c('div', {
      staticClass: "ec-filenames-foot"
    }, [_c('span', {
      staticClass: "ec-var-hint"
    }, [_vm._v("\".pdf\" is added if left off. Changes this file's name for every template using it, as soon as you save it.")]), _vm._v(" "), _c('button', {
      staticClass: "nc-btn nc-btn-ghost nc-btn-sm",
      attrs: {
        "disabled": _vm.saving || !_vm.fileNamesChanged(group)
      },
      on: {
        "click": function($event) {
          return _vm.saveFileNames(group)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    }), _vm._v(" Save names\n                    ")])])], 2) : _vm._e(), _vm._v(" "), (_vm.mediaPickerFor(group).open) ? _c('div', {
      staticClass: "ec-media-picker"
    }, [(_vm.mediaPickerFor(group).loading) ? _c('p', {
      staticClass: "ec-main-note"
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-spin"
    }), _vm._v(" Loading Media Management…")]) : (_vm.mediaPickerFor(group).error) ? _c('p', {
      staticClass: "ec-media-problem"
    }, [_vm._v(_vm._s(_vm.mediaPickerFor(group).error))]) : (_vm.mediaPickerFor(group).info) ? [_c('p', {
      staticClass: "ec-media-target"
    }, [_vm._v("\n                      Changing the " + _vm._s(_vm.mediaPickerFor(group).info.label.toLowerCase()) + " for\n                      "), _c('strong', [_vm._v(_vm._s(_vm.mediaPickerFor(group).languageName || 'every language'))])]), _vm._v(" "), _c('p', {
      staticClass: "ec-main-note"
    }, [_vm._v("\n                      Applies to the template, so it changes the header for\n                      "), _c('strong', [_vm._v(_vm._s(_vm.mediaPickerFor(group).info.campaigns) + " campaign" + _vm._s(_vm.mediaPickerFor(group).info.campaigns === 1 ? '' : 's'))]), _vm._v("\n                      using it, as soon as you apply it (not on Save). Only " + _vm._s(_vm.mediaPickerFor(group).info.label.toLowerCase()) + "s\n                      with a file in every language (" + _vm._s(_vm.mediaPickerFor(group).info.languages.join(', ')) + ") for\n                      " + _vm._s(_vm.mediaPickerFor(group).info.countries.join(', ') || 'these countries') + " are listed.\n                      Upload new files in "), _c('router-link', {
      attrs: {
        "to": "/media-management/view"
      }
    }, [_vm._v("Media Management")]), _vm._v(".\n                    ")], 1), _vm._v(" "), (_vm.mediaPickerFor(group).info.skippedCountries.length) ? _c('p', {
      staticClass: "ec-main-note"
    }, [_vm._v("\n                      Not checked for " + _vm._s(_vm.mediaPickerFor(group).info.skippedCountries.join(', ')) + ": no WhatsApp account there.\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.mediaPickerFor(group).info.options.length) ? _c('p', {
      staticClass: "ec-media-problem"
    }, [_vm._v("\n                      Nothing in Media Management fits. Upload " + _vm._s(_vm.mediaPickerFor(group).info.hint) + " for those languages first.\n                    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.mediaPickerFor(group).info.options), function(option) {
      return _c('label', {
        key: option.id,
        staticClass: "ec-media-option",
        class: {
          'is-current': _vm.mediaPickerFor(group).info.currentMediaIds.indexOf(option.id) !== -1
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.mediaPickerFor(group).selected),
          expression: "mediaPickerFor(group).selected"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": option.id,
          "checked": _vm._q(_vm.mediaPickerFor(group).selected, option.id)
        },
        on: {
          "change": function($event) {
            _vm.$set(_vm.mediaPickerFor(group), "selected", option.id)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "ec-media-option-thumb"
      }, [_c('media-preview', {
        attrs: {
          "compact": "",
          "show-caption": false,
          "format": option.format || _vm.mediaPickerFor(group).info.headerType,
          "media-id": option.id,
          "media-name": option.name,
          "file-name": option.fileName || '',
          "country-id": _vm.raw.country_id,
          "language-id": _vm.mediaPickerFor(group).languageId
        }
      })], 1), _vm._v(" "), _c('span', {
        staticClass: "ec-media-option-name"
      }, [_vm._v(_vm._s(option.name))]), _vm._v(" "), _c('span', {
        staticClass: "ec-media-option-meta"
      }, [_vm._v(_vm._s(option.format)), (option.fileName) ? _c('span', [_vm._v(" · " + _vm._s(option.fileName))]) : _vm._e()]), _vm._v(" "), (_vm.mediaPickerFor(group).info.currentMediaIds.indexOf(option.id) !== -1) ? _c('span', {
        staticClass: "nc-badge nc-badge-teal"
      }, [_vm._v("Current")]) : _vm._e()])
    }), _vm._v(" "), (_vm.mediaPickerFor(group).info.options.length) ? _c('button', {
      staticClass: "nc-btn nc-btn-primary nc-btn-sm",
      attrs: {
        "disabled": !_vm.mediaPickerFor(group).selected || _vm.mediaPickerFor(group).info.currentMediaIds.indexOf(_vm.mediaPickerFor(group).selected) !== -1
      },
      on: {
        "click": function($event) {
          return _vm.applyMedia(group)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    }), _vm._v(" Use this file\n                    ")]) : _vm._e()] : _vm._e()], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (!group.messages.length) ? _c('p', {
      staticClass: "ec-main-note"
    }, [_vm._v("\n                This group has no message rows stored, so there's nothing to edit here.\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((group.messages), function(message) {
      return _c('div', {
        key: ((group.key) + "-" + (message.lang_id)),
        staticClass: "ec-lang",
        class: {
          'is-open': _vm.isOpen(group, message),
          'is-flagged': _vm.isFlagged(message)
        }
      }, [_c('button', {
        staticClass: "ec-lang-head",
        attrs: {
          "aria-expanded": _vm.isOpen(group, message) ? 'true' : 'false'
        },
        on: {
          "click": function($event) {
            return _vm.toggle(group, message)
          }
        }
      }, [_c('span', {
        staticClass: "ec-lang-code"
      }, [_vm._v(_vm._s(message.language))]), _vm._v(" "), _c('span', {
        staticClass: "ec-lang-name"
      }, [_vm._v(_vm._s(_vm.languageName(message.language)))]), _vm._v(" "), _c('span', {
        staticClass: "ec-lang-preview"
      }, [_vm._v(_vm._s(_vm.previewOf(message)))]), _vm._v(" "), _c('i', {
        staticClass: "fa fa-caret-right ec-lang-caret"
      })]), _vm._v(" "), (_vm.isOpen(group, message)) ? _c('div', {
        staticClass: "ec-lang-body",
        class: {
          'has-preview': _vm.previewOn(group)
        }
      }, [_c('div', {
        staticClass: "ec-editor"
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (message.message),
          expression: "message.message"
        }],
        staticClass: "nc-input ec-textarea",
        attrs: {
          "rows": "4",
          "aria-label": ((_vm.languageName(message.language)) + " message")
        },
        domProps: {
          "value": (message.message)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(message, "message", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "ec-lang-foot"
      }, [_c('span', {
        staticClass: "ec-count",
        class: {
          'is-over': _vm.lengthOf(message) > _vm.maxBodyChars
        }
      }, [_vm._v("\n                        " + _vm._s(_vm.lengthOf(message)) + " / " + _vm._s(_vm.maxBodyChars) + " chars\n                      ")]), _vm._v(" "), (_vm.lengthOf(message) > _vm.maxBodyChars) ? _c('span', {
        staticClass: "ec-count-warn"
      }, [_vm._v("\n                        Over the WhatsApp body limit — trim it before saving.\n                      ")]) : (!_vm.lengthOf(message)) ? _c('span', {
        staticClass: "ec-count-warn"
      }, [_vm._v("\n                        Empty — this language won't be sent.\n                      ")]) : _vm._e()]), _vm._v(" "), (_vm.slotsFor(group, message).length) ? _c('div', {
        staticClass: "ec-vars"
      }, [_vm._m(4, true), _vm._v(" "), (!_vm.variablesFor(group, message).dynamic) ? _c('p', {
        staticClass: "ec-media-problem"
      }, [_c('i', {
        staticClass: "fa fa-exclamation-triangle"
      }), _vm._v("\n                        This template has variables but isn't marked Dynamic in Nudge Template Manager, so the\n                        sender won't fill them and WhatsApp will reject the send. Turn on \"Dynamic\" there first.\n                      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.slotsFor(group, message)), function(slot) {
        return _c('div', {
          key: slot.key,
          staticClass: "ec-var-row"
        }, [_c('span', {
          staticClass: "ec-var-label"
        }, [_vm._v(_vm._s(slot.label))]), _vm._v(" "), _c('nv-select', {
          staticClass: "nc-input ec-var-source",
          attrs: {
            "aria-label": ((slot.label) + " source")
          },
          model: {
            value: (slot.entry.source),
            callback: function($$v) {
              _vm.$set(slot.entry, "source", $$v)
            },
            expression: "slot.entry.source"
          }
        }, [_c('option', {
          attrs: {
            "value": ""
          }
        }, [_vm._v("Choose…")]), _vm._v(" "), _vm._l((_vm.variableSources), function(option) {
          return _c('option', {
            key: option.value,
            domProps: {
              "value": option.value
            }
          }, [_vm._v(_vm._s(option.label))])
        })], 2), _vm._v(" "), (slot.entry.source === 'text') ? _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (slot.entry.text),
            expression: "slot.entry.text"
          }],
          staticClass: "nc-input ec-var-text",
          attrs: {
            "type": "text",
            "placeholder": ("Text in " + (_vm.languageName(message.language))),
            "aria-label": ((slot.label) + " text")
          },
          domProps: {
            "value": (slot.entry.text)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(slot.entry, "text", $event.target.value)
            }
          }
        }) : (slot.entry.source) ? _c('span', {
          staticClass: "ec-var-hint"
        }, [_vm._v("Filled per user by the sender")]) : _vm._e()], 1)
      })], 2) : _vm._e()]), _vm._v(" "), (_vm.previewOn(group)) ? _c('div', {
        staticClass: "ec-preview"
      }, [_c('div', {
        staticClass: "ec-phone"
      }, [_c('div', {
        staticClass: "ec-bubble"
      }, [(_vm.previewFor(group, message)) ? [(_vm.previewFor(group, message).media) ? _c('media-preview', {
        attrs: {
          "format": _vm.previewFor(group, message).media.format,
          "media-id": _vm.previewFor(group, message).media.mediaId,
          "media-name": _vm.previewFor(group, message).media.mediaName,
          "file-name": _vm.previewFor(group, message).media.fileName,
          "country-id": _vm.raw.country_id,
          "language-id": _vm.previewFor(group, message).media.languageId
        }
      }) : _vm._e(), _vm._v(" "), (_vm.previewFor(group, message).header) ? _c('div', {
        staticClass: "ec-bubble-header"
      }, [_vm._l((_vm.previewFor(group, message).header.parts), function(seg, si) {
        return _c('span', {
          key: ("h" + si)
        }, [_c('span', [_vm._v(_vm._s(seg.text))]), _vm._v(" "), _c('span', {
          staticClass: "ec-var",
          class: {
            'is-unset': !seg.value
          }
        }, [_vm._v(_vm._s(seg.value || seg.token))])])
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.previewFor(group, message).header.last))])], 2) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "ec-bubble-body"
      }, [_vm._l((_vm.previewFor(group, message).body.parts), function(seg, si) {
        return _c('span', {
          key: ("b" + si)
        }, [_c('span', [_vm._v(_vm._s(seg.text))]), _vm._v(" "), _c('span', {
          staticClass: "ec-var",
          class: {
            'is-unset': !seg.value
          }
        }, [_vm._v(_vm._s(seg.value || seg.token))])])
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.previewFor(group, message).body.last))])], 2), _vm._v(" "), (_vm.previewFor(group, message).footer) ? _c('div', {
        staticClass: "ec-bubble-footer"
      }, [_vm._v("\n                            " + _vm._s(_vm.previewFor(group, message).footer) + "\n                          ")]) : _vm._e()] : _c('div', {
        staticClass: "ec-bubble-body"
      }, [_vm._v(_vm._s(message.message || 'No message set'))]), _vm._v(" "), _c('div', {
        staticClass: "ec-bubble-meta"
      }, [_vm._v(_vm._s(_vm.nowTime) + " "), _c('i', {
        staticClass: "fa fa-check"
      }), _c('i', {
        staticClass: "fa fa-check"
      })])], 2), _vm._v(" "), _vm._l((_vm.previewButtons(group, message)), function(button, bi) {
        return _c('div', {
          key: ("btn" + bi),
          staticClass: "ec-bubble-button"
        }, [_c('i', {
          staticClass: "fa fa-reply"
        }), _vm._v(" " + _vm._s(button) + "\n                      ")])
      })], 2), _vm._v(" "), _c('p', {
        staticClass: "ec-preview-note"
      }, [_vm._v(_vm._s(_vm.previewNote(group, message)))])]) : _vm._e()]) : _vm._e()])
    }), _vm._v(" "), _c('h5', {
      staticClass: "ec-sub-title"
    }, [_vm._v("Where a reply lands")]), _vm._v(" "), _vm._l((group.destinations), function(destination, di) {
      return _c('div', {
        key: ((group.key) + "-dest-" + di),
        staticClass: "ec-dest"
      }, [(destination.type === 'website_link') ? [_c('div', {
        staticClass: "ec-dest-locked"
      }, [_c('span', {
        staticClass: "ec-rail-fact-label"
      }, [_vm._v("Website link")]), _vm._v(" "), _c('span', {
        staticClass: "ec-rail-fact-value"
      }, [_vm._v("\n                      Link #" + _vm._s(destination.websiteLink) + " — kept as-is, edit website links in Database Marketing\n                    ")])])] : [_c('nv-select', {
        staticClass: "nc-input ec-dest-type",
        attrs: {
          "aria-label": "Destination type"
        },
        model: {
          value: (destination.type),
          callback: function($$v) {
            _vm.$set(destination, "type", $$v)
          },
          expression: "destination.type"
        }
      }, [_c('option', {
        attrs: {
          "value": "keyword"
        }
      }, [_vm._v("Keyword")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "destination_conversation"
        }
      }, [_vm._v("Conversation")])]), _vm._v(" "), (destination.type === 'keyword') ? _c('nv-select', {
        staticClass: "nc-input ec-dest-target",
        attrs: {
          "aria-label": "Keyword"
        },
        model: {
          value: (destination.keywordId),
          callback: function($$v) {
            _vm.$set(destination, "keywordId", $$v)
          },
          expression: "destination.keywordId"
        }
      }, [_c('option', {
        domProps: {
          "value": null
        }
      }, [_vm._v("Choose a keyword…")]), _vm._v(" "), _vm._l((_vm.keywordList), function(keyword) {
        return _c('option', {
          key: keyword.id,
          domProps: {
            "value": keyword.id
          }
        }, [_vm._v(_vm._s(keyword.keyword))])
      })], 2) : _c('nv-select', {
        staticClass: "nc-input ec-dest-target",
        attrs: {
          "aria-label": "Conversation"
        },
        model: {
          value: (destination.conversationId),
          callback: function($$v) {
            _vm.$set(destination, "conversationId", $$v)
          },
          expression: "destination.conversationId"
        }
      }, [_c('option', {
        domProps: {
          "value": null
        }
      }, [_vm._v("Choose a conversation…")]), _vm._v(" "), _vm._l((_vm.conversationList), function(app) {
        return _c('option', {
          key: app.id,
          domProps: {
            "value": app.id
          }
        }, [_vm._v(_vm._s(app.appName))])
      })], 2), _vm._v(" "), (group.destinations.length > 1) ? _c('button', {
        staticClass: "nc-btn nc-btn-sm nc-btn-danger",
        attrs: {
          "title": "Remove this destination"
        },
        on: {
          "click": function($event) {
            return group.destinations.splice(di, 1)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash-o"
      })]) : _vm._e()]], 2)
    }), _vm._v(" "), _c('button', {
      staticClass: "nc-btn nc-btn-ghost nc-btn-sm ec-add-dest",
      on: {
        "click": function($event) {
          return _vm.addDestination(group)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    }), _vm._v(" Add a destination\n              ")])], 2)
  }), _vm._v(" "), (_vm.form.groups.length < 2) ? _c('button', {
    staticClass: "nc-btn nc-btn-ghost nc-btn-sm ec-add-variant",
    attrs: {
      "disabled": "",
      "title": "Variant B needs its own approved template — add it in Create Campaign"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Variant B (in Create Campaign only)\n            ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ec-footer"
  }, [_c('div', {
    staticClass: "ec-footer-facts"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-language"
  }), _vm._v(" " + _vm._s(_vm.languageCountText))]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" " + _vm._s(_vm.variantCountText))])]), _vm._v(" "), _c('div', {
    staticClass: "ec-footer-actions"
  }, [_c('router-link', {
    staticClass: "nc-btn nc-btn-ghost",
    attrs: {
      "to": "/nudge-console/dashboard"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "nc-btn nc-btn-ghost",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Save changes\n            ")]), _vm._v(" "), (_vm.raw.opportunity_status !== _vm.activeStatus) ? _c('button', {
    staticClass: "nc-btn nc-btn-primary",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o"
  }), _vm._v(" Save & activate\n            ")]) : _vm._e()], 1)])])] : _vm._e()], 2), _vm._v(" "), (_vm.loading || _vm.saving) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nc-empty-icon"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ec-avatar"
  }, [_c('i', {
    staticClass: "fa fa-commenting-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ec-vars-title"
  }, [_vm._v("\n                    PDF name in chat\n                    "), _c('span', {
    staticClass: "ec-vars-sub"
  }, [_vm._v("what the person sees in WhatsApp, per language")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ec-vars-title"
  }, [_vm._v("\n                        Template values\n                        "), _c('span', {
    staticClass: "ec-vars-sub"
  }, [_vm._v("what fills each "), _c('span', {
    pre: true
  }, [_vm._v("{{n}}")]), _vm._v(" when this is sent")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-82336308","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge-console/EditCampaign.vue
// module id = sxnB
// module chunks = 1